// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ModeStatus {
  Attendant = 0,
  Simplex = 1,
  IR = 2,
  VIP = 3,
  Security = 4,
  MOS = 5,
  InService = 6,
  Inspection = 7,
  Independent = 8,
  LobbyParking = 9,
  CarToLobby = 10,
  CodeBlue = 11,
  FirePhase2 = 12,
  GroupService = 13
}
